module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxMCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0wIDBIOEw5IDFMMTAgMlYxNEgwVjBaIiBmaWxsPSIjMkEzMTRFIi8+DQo8bGluZSB4MT0iMS41IiB5MT0iMyIgeDI9IjguNSIgeTI9IjMiIHN0cm9rZT0id2hpdGUiLz4NCjxsaW5lIHgxPSIxLjUiIHkxPSI1LjUiIHgyPSI4LjUiIHkyPSI1LjUiIHN0cm9rZT0id2hpdGUiLz4NCjxsaW5lIHgxPSIxLjUiIHkxPSI4IiB4Mj0iOC41IiB5Mj0iOCIgc3Ryb2tlPSJ3aGl0ZSIvPg0KPGxpbmUgeDE9IjEuNSIgeTE9IjEwLjUiIHgyPSI1IiB5Mj0iMTAuNSIgc3Ryb2tlPSJ3aGl0ZSIvPg0KPC9zdmc+DQo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/learning/course-description-icon.svg
// module id = 716
// module chunks = 0